const RECKON_DOMAIN = 'wereckon.com';
const DRAFT_MODE_STORAGE_KEY = 'reckon:draft-mode';

function normalizeEmail(email) {
  return typeof email === 'string' ? email.trim().toLowerCase() : '';
}

function isAuthorizedReckonUser(user) {
  if (!user?.email || !user.emailVerified) return false;
  const parts = normalizeEmail(user.email).split('@');
  return parts.length === 2 && parts[1] === RECKON_DOMAIN;
}

function isPublished(status) {
  return !status || status === 'published';
}

function canViewContent(status, draftModeEnabled, authorizedUser) {
  return isPublished(status) || (draftModeEnabled && authorizedUser);
}

function visibleContent(items, draftModeEnabled, authorizedUser) {
  return (items || []).filter((item) => (
    canViewContent(item?.status, draftModeEnabled, authorizedUser)
  ));
}

function canLinkToContent(item, draftModeEnabled, authorizedUser) {
  return Boolean(item && canViewContent(item.status, draftModeEnabled, authorizedUser));
}

function publicDiscoveryContent(items) {
  return (items || []).filter((item) => isPublished(item?.status));
}

function readDraftModePreference(storage) {
  try {
    return storage?.getItem(DRAFT_MODE_STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

function writeDraftModePreference(storage, enabled) {
  try {
    if (enabled) storage?.setItem(DRAFT_MODE_STORAGE_KEY, 'true');
    else storage?.removeItem(DRAFT_MODE_STORAGE_KEY);
  } catch (error) {
    // Storage can be unavailable in private browsing. Draft Mode still works for this session.
  }
}

module.exports = {
  DRAFT_MODE_STORAGE_KEY,
  RECKON_DOMAIN,
  canViewContent,
  canLinkToContent,
  isAuthorizedReckonUser,
  isPublished,
  normalizeEmail,
  readDraftModePreference,
  publicDiscoveryContent,
  visibleContent,
  writeDraftModePreference,
};
